/**
 * Custom Model Service
 *
 * Handles all custom model-related API calls
 */

import api from './api';

const customModelService = {
  /**
   * Get available attributes for a sport
   * @param {string} sport - Sport filter (nfl, nba, mlb, nhl, ncaa_f) or null for all
   * @returns {Promise} Array of attributes
   */
  getAttributes: async (sport = null) => {
    const params = sport ? { sport } : {};
    const response = await api.get('/custom-models/attributes', { params });
    return response.data;
  },

  /**
   * Get user's custom models
   * @param {string} sport - Optional sport filter
   * @returns {Promise} Array of user models
   */
  getModels: async (sport = null) => {
    const params = sport ? { sport } : {};
    const response = await api.get('/custom-models', { params });
    return response.data;
  },

  /**
   * Get single model by ID
   * @param {number} modelId - Model ID
   * @returns {Promise} Model data
   */
  getModel: async (modelId) => {
    const response = await api.get(`/custom-models/${modelId}`);
    return response.data;
  },

  /**
   * Create a new custom model
   * @param {object} modelData - Model data
   * @returns {Promise} Created model
   */
  createModel: async (modelData) => {
    const response = await api.post('/custom-models', modelData);
    return response.data;
  },

  /**
   * Update an existing model
   * @param {number} modelId - Model ID
   * @param {object} modelData - Updated model data
   * @returns {Promise} Updated model
   */
  updateModel: async (modelId, modelData) => {
    const response = await api.patch(`/custom-models/${modelId}`, modelData);
    return response.data;
  },

  /**
   * Delete a model
   * @param {number} modelId - Model ID
   * @returns {Promise}
   */
  deleteModel: async (modelId) => {
    await api.delete(`/custom-models/${modelId}`);
  },
};

export default customModelService;
